import React, { Component } from 'react';

class ListFileUpload extends Component {
    render() {
        return (
            <div id='list-file-upload'>
                <p>{this.props.fileUpload ? this.props.fileUpload.name : null}</p>
            </div>
        );
    }
}

export default ListFileUpload;


// WEBPACK FOOTER //
// ./src/components/upload-file/ListFileUpload.js